import React from 'react';
import { Box, CssBaseline, Container } from '@mui/material';
import type { Breakpoint } from '@mui/material/styles';
import Header from './Header';
import Footer from './Footer';

interface MainLayoutProps {
  children: React.ReactNode;
  containerMaxWidth?: Breakpoint | false;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, containerMaxWidth }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <CssBaseline />
      <Header />
      <Container maxWidth={containerMaxWidth ?? 'lg'} component="main" sx={{ mt: 4, mb: 4, flex: 1 }}>
        {children}
      </Container>
      <Footer />
    </Box>
  );
};

export default MainLayout;
